export default __webpack_public_path__ + "static/caption-02-chs-7fedfa711fdfa44165c53a65566391f5.png";